import { render, staticRenderFns } from "./ReviewsPopUp.vue?vue&type=template&id=4d0f76c1&scoped=true&"
import script from "./ReviewsPopUp.vue?vue&type=script&lang=js&"
export * from "./ReviewsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsPopUp.vue?vue&type=style&index=0&id=4d0f76c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0f76c1",
  null
  
)

export default component.exports